import { observer } from 'mobx-react-lite'
import { useNewInboxStepsContext } from 'pages/settings/pages/inboxes/pages/newInbox/context/newInboxStepsContext'
import { InboxCommonPayment } from 'pages/settings/ui/InboxCommonPayment/InboxCommonPayment'

export const Payment = observer(() => {
  const {
    addSalesmsgNumbersStore: { numbersStore },
    paymentStore,
    createInbox,
    stepLoading,
    chooseNumberStore: { chooseNumberTabsStore },
    selectAppAndNumbersStore,
    textEnableLandlineStore,
    commonStore: { selectedNumbersCount, shouldShowPaymentNumbersList, isBuyingNumber },
  } = useNewInboxStepsContext()
  const { multiSelectedValues: numbers } = numbersStore
  const appSelectedNumber = selectAppAndNumbersStore.selectedNumber
  const phone = textEnableLandlineStore.phone

  return (
    <InboxCommonPayment
      textEnableLandlinePhone={phone}
      salesmsgNumbers={numbers}
      appSelectedNumber={appSelectedNumber}
      shouldShowPaymentNumbersList={shouldShowPaymentNumbersList}
      isBuyingNumber={isBuyingNumber}
      licensesRequired={selectedNumbersCount}
      stepLoading={stepLoading}
      paymentStore={paymentStore}
      chooseNumberTabsStore={chooseNumberTabsStore}
      handleOnClick={() => createInbox()}
      buttonText={`${appSelectedNumber ? 'Add' : 'Buy'} & create inbox`}
    />
  )
})
